import React from "react";
import { useStoredItem } from "../../../state/InternalContext";

interface ItemHasChildrenProps {
    item: string,
}

/***
 * A source component that returns whether a stored item has children.
 * 
 * Params:
 *      name: The name of the item
 */
export const ItemHasChildren = React.memo(function ItemHasChildren({ item }: ItemHasChildrenProps): React.ReactElement {
    const storedItem = useStoredItem(item);
    return <>{storedItem?.children?.length ? 'true' : 'false'}</>;
});